import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize auth state from storage
    const initializeAuth = async () => {
      try {
        const storedToken = localStorage.getItem('adminToken');
        const storedUser = localStorage.getItem('adminUser');
        
        if (storedToken && storedUser) {
          // Optional: Validate token with backend
          // const isValid = await validateToken(storedToken);
          // if (isValid) {
            setToken(storedToken);
            setCurrentUser(JSON.parse(storedUser));
          // }
        }
      } catch (error) {
        clearAuth();
      } finally {
        setLoading(false);
      }
    };
    
    initializeAuth();
  }, []);

  const login = (userData, authToken) => {
    localStorage.setItem('adminToken', authToken);
    localStorage.setItem('adminUser', JSON.stringify(userData));
    setCurrentUser(userData);
    setToken(authToken);
  };

  const logout = () => {
    clearAuth();
    navigate('/login');
  };

  const clearAuth = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setCurrentUser(null);
    setToken(null);
  };

  const value = {
    currentUser,
    token,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}